// extracted by mini-css-extract-plugin
export default {"cardsGroup":"CardsGroup_cardsGroup__fm9Uh","cardsGroupMobile":"CardsGroup_cardsGroupMobile__2AfRD","card":"CardsGroup_card__0uQQv"};